import clsx from 'clsx';
import { Box, Grid } from '@mui/material';

import ListRefreshButton from '../../../buttons/ListRefreshButton';
import Search from '../../../filter/Search';
import Pagination from '../../../filter/Pagination';
import PaginationOrder from '../../../filter/PaginationOrder';
import SelectAllItemsCheckbox from '../../../buttons/SelectAllItemsCheckbox';

import { type PaginationBaseProps } from './ViewPagination';
import PaginationButtons from './PaginationButtons';

export default function DesktopPagination(props: PaginationBaseProps) {
	const { filterProps, orderProps, paginatorProps } = props.paginationProps;

	return (
		<Box className={clsx('p-8', props.className)}>
			<Grid container justifyContent="space-between" alignItems="center" spacing={1}>
				<Grid>
					<Grid container alignItems="center" spacing={1}>
						{props.isSelecting && (
							<Grid>
								<SelectAllItemsCheckbox selectedItems={props.selectedItems} />
							</Grid>
						)}
						<Grid>
							<ListRefreshButton
								isLoading={paginatorProps.isLoading}
								updateRefresh={props.updateRefresh}
							/>
						</Grid>
						{props.showFilters && filterProps && (
							<Grid>
								<Search
									module={props.module}
									filters={filterProps.filters}
									handleFilterChange={filterProps.handleFilterChange}
									handleFiltersApply={filterProps.handleFiltersApply}
								/>
							</Grid>
						)}
						<Grid>
							<PaginationButtons
								module={props.module}
								filterProps={filterProps}
								visibleFilters={props.visibleFilters}
								additionalButtons={props.additionalButtons}
								showFilters={props.showFilters}
								showExportButton={props.showExportButton}
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid size="grow">
					<Grid container justifyContent="flex-end" spacing={1}>
						{props.showOrder && props.visibleOrderFilters && (
							<Grid>
								<PaginationOrder module={props.module} {...orderProps} />
							</Grid>
						)}
						<Grid>
							<Pagination {...paginatorProps} />
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Box>
	);
}
